'use strict';

const originatorPanel = {
  bindings: {
    data: '<'
  },
  require: {
    originatorSelect: '^^originatorSelect'
  },
  template: `
    <div class="panel" ng-class="{ selected: $ctrl.data.loggedIn }" ng-click="$ctrl.originatorSelect.select($ctrl.data)">
      <div class="row">
        <div class="large-4 small-4 columns">
          <logo id="$ctrl.data.id" />
        </div>

        <div class="large-8 small-8 columns" style="color: black">
          <h4>
            {{ $ctrl.data.name }}
            <small ng-if="$ctrl.data.loggedIn" style="color: var(--grey4) !important;">(valgt)</small>
          </h4>

          <p class="lead" ng-if="$ctrl.data.role === 'OWNER'">EIER</p>
          <p class="lead" ng-if="$ctrl.data.role === 'ISSUER'">UTSTEDER</p>
          <p class="lead" ng-if="$ctrl.data.role === 'VIEWER'">LESETILGANG</p>
        </div>
      </div>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('originatorPanel', originatorPanel);
